import { useCallback, useState } from 'react'

export const useDateNavigation = (initialDate: Date) => {
    const [selectedDate, setSelectedDate] = useState<Date>(initialDate)

    const handlePreviousMonth = useCallback(() => {
        setSelectedDate((prevDate) => {
            const newDate = new Date(prevDate)
            newDate.setMonth(newDate.getMonth() - 1)
            return newDate
        })
    }, [])

    const handleNextMonth = useCallback(() => {
        setSelectedDate((prevDate) => {
            const newDate = new Date(prevDate)
            newDate.setMonth(newDate.getMonth() + 1)
            return newDate
        })
    }, [])

    return {
        selectedDate,
        handlePreviousMonth,
        handleNextMonth,
    }
}
